import styled from 'styled-components';
import { FormControl } from '@material-ui/core';
import { DSText } from '@engenharia/ds-react';
import SelectCountry from '../../components/SelectCountry';
import spaces from '../../styles/theme/spaces';

const EmailSuggest = styled(DSText)`
  color: #747474;
  font-weight: 400;
  margin-left: 14px;
  margin-top: 8px;
  text-align: left;

  & > strong {
    font-style: italic;
    font-weight: 700;
  }
`;

const PhoneFieldsContainer = styled(FormControl)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 0;
`;

const SelectCountryField = styled(SelectCountry)`
  width: 115px;
  flex-shrink: 0;
  margin-right: 8px;
  margin-top: 16px;
`;

const WhatsAppCheckboxContainer = styled(FormControl)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  & > .MuiCheckbox-root {
    padding: 0;
    color: #1a73e8;
  }

  & > p {
    color: #757575;
    letter-spacing: normal;
  }
`;

const HeaderContent = styled.div`
 margin-bottom: 10px;
`;

export {
  EmailSuggest,
  PhoneFieldsContainer,
  SelectCountryField,
  WhatsAppCheckboxContainer,
  HeaderContent,
};
